import { useEffect, useState } from 'react'
import { get } from '../../../Services/api'
import yyyy_mm_dd_date_format from '../../../Utility/yyyy_mm_dd_date_format';

import './Grocery.css'

function Grocery({ currentUser }) {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [shoppingList, setShoppingList] = useState([]);
    const [viewMode, setViewMode] = useState('full'); // 'full' or 'meal-based'
    const today = yyyy_mm_dd_date_format({})

    useEffect(() => {
        setStartDate(today);
        setEndDate(today);
    }, []);

    useEffect(() => {
        if (startDate && endDate) {
            getShoppingList();
        }
    }, [startDate, endDate]);

    async function getShoppingList() {
        const result = await get("/api/shopping-list/get_full_list",
            {
                user_id: currentUser.uid,
                start_date: startDate,
                end_date: endDate,
                country_code: 'US'
            })
        setShoppingList(result)
    }

    function aggregateIngredients(ingredients) {
        const aggregated = new Map();

        ingredients.forEach(item => {
            const key = `${item.ingredient_name}-${item.unit_name}`;
            const amount = parseFloat(item.amount);
            const ingredientImage = item.ingredient_image; // Capture the image

            if (aggregated.has(key)) {
                // Update amount and keep the image
                const [currentAmount, currentImage] = aggregated.get(key);
                aggregated.set(key, [currentAmount + amount, currentImage]);
            } else {
                // Initialize with amount and image
                aggregated.set(key, [amount, ingredientImage]);
            }
        });

        // Transform the aggregated Map into an array of objects
        return Array.from(aggregated, ([key, [amount, ingredient_image]]) => {
            const [ingredient_name, unit_name] = key.split('-');
            return {
                ingredient_image,
                ingredient_name,
                unit_name,
                amount: amount.toString()
            };
        });
    }


    function aggregateIngredientsByMeal(ingredients) {
        const meals = {};

        ingredients.forEach(item => {
            const mealKey = `${item.meal_name}-${item.meal_date}-${item.course}`;

            // Initialize the meal object if it doesn't exist
            if (!meals[mealKey]) {
                meals[mealKey] = {
                    meal_name: item.meal_name,
                    meal_date: item.meal_date,
                    course: item.course,
                    total_cost: item.total_cost,
                    ingredients: []
                };
            }

            const existing = meals[mealKey].ingredients.find(i => i.ingredient_name === item.ingredient_name && i.unit_name === item.unit_name);
            if (existing) {
                existing.amount += parseFloat(item.amount);
            } else {
                meals[mealKey].ingredients.push({
                    ingredient_name: item.ingredient_name,
                    unit_name: item.unit_name,
                    amount: parseFloat(item.amount),
                });
            }
        });

        // Convert the meals object to an array of meal objects
        return Object.values(meals);
    }


    return (
        <div className="component_padding black">
            <div>
                <h4 className='font_family_ovo no_margin'>Grocery List</h4>
            </div>

            <div className='component_heading_separating_line'></div>

            <div style={{ paddingRight: '20px' }} className="dashboard-shopping-list-item gray_scale_3 font_weight_600">
                <p className='no_margin'>Item</p>
                <div></div>
                <p className='no_margin'>Quantity</p>
            </div>

            <div className="dashboard-shopping-list-items-container flex flex_column">
                {shoppingList.length > 0 ? (
                    viewMode === 'full' ? (
                        aggregateIngredients(shoppingList).map(item => (
                            <div key={item.ingredient_name + item.unit_name} className="dashboard-shopping-list-item gray_scale_2">
                                <img src={item.ingredient_image} className='dashboard-shopping-list-item-img' />
                                <p className='no_margin'>{item.ingredient_name}</p>
                                <p className='no_margin'>{item.amount ? `${item.amount} ${item.unit_name || ""}` : "Amount not provided."}</p>
                            </div>
                        ))
                    ) : (
                        aggregateIngredientsByMeal(shoppingList).map(meal => (
                            <div key={meal.meal_name + meal.meal_date} className="shopping-list-meal-container">
                                <h3>{meal.meal_name}</h3>
                                <p>{meal.course}</p>
                                <p>{meal.meal_date}</p>
                                <p>${meal.total_cost}</p>
                                <div className="shopping-list-meal-ingredients">
                                    {meal.ingredients.map(item => (
                                        <div key={item.ingredient_name + item.unit_name} className="shopping-list-item">
                                            <p>{item.ingredient_name}</p>
                                            <p>{item.amount ? `${item.amount} ${item.unit_name || ""}` : "Amount not provided."}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))
                    )
                ) : (
                    <p className="shopping-list-no-items-text">No items to show</p>
                )}
            </div>
        </div>
    );
}


export default Grocery;